module.exports = __webpack_public_path__ + "static/media/landing-animated.d030e2db.svg";